// Admin API client for the BHI assessment kiosk. Uses the app's authed fetch
// helper (cookies + JWT), same convention as kiosk-admin-api.js.
// Confirmed convention: `api.delete()` (not `.del()`), `ccmApi.getSettings/saveSettings`
// for the shared /data/settings endpoints.
import { api, ccmApi } from './api';

// ── Facilities ──────────────────────────────────────────────────────────────
export const listFacilities   = ()           => api.get('/data/facilities');
export const createFacility   = (name)       => api.post('/data/facilities', { name });
export const archiveFacility  = (id)         => api.delete(`/data/facilities/${id}`);
// Elation tags that mark a resident of the facility (migration 078); the
// server stores them normalized (lower-cased) and returns the facility row,
// with resident_charts (the scope size) computed over the new tags.
export const setFacilityTags  = (id, elationTags) => api.patch(`/data/facilities/${id}`, { elationTags });
// Distinct directory tags with their chart counts, `{ tags: [{ tag, charts }] }`,
// for the tag autocomplete.
export const listDirectoryTags = ()          => api.get('/data/facilities/directory-tags');

// ── Residents ───────────────────────────────────────────────────────────────
export const listResidents    = (fid)              => api.get(`/data/facilities/${fid}/residents`);
export const addResident      = (fid, patientId)   => api.post(`/data/facilities/${fid}/residents`, { patientId });
export const removeResident   = (fid, patientId)   => api.delete(`/data/facilities/${fid}/residents/${patientId}`);

// ── Caregivers ──────────────────────────────────────────────────────────────
export const listCaregivers   = (fid)        => api.get(`/data/facilities/${fid}/caregivers`);
export const createCaregiver  = (fid, body)  => api.post(`/data/facilities/${fid}/caregivers`, body);
export const revokeCaregiver  = (fid, cid)   => api.delete(`/data/facilities/${fid}/caregivers/${cid}`);

// ── Devices ─────────────────────────────────────────────────────────────────
export const listDevices      = (fid)        => api.get(`/data/facilities/${fid}/devices`);
export const mintDevice       = (fid, label) => api.post(`/data/facilities/${fid}/devices`, { label });
export const revokeDevice     = (fid, did)   => api.delete(`/data/facilities/${fid}/devices/${did}`);

// ── Settings ─────────────────────────────────────────────────────────────────
// Reuse the shared /data/settings endpoints (same as ccmApi.getSettings /
// saveSettings) — no separate routes needed for assessment-kiosk settings.
export const getSettings  = () => ccmApi.getSettings();
export const saveSettings = (patch) => ccmApi.saveSettings(patch);

// ── Patients ──────────────────────────────────────────────────────────────────
// Practice patients (for the resident picker) — reuse the shared endpoint.
export const listPatients = () => ccmApi.listPatients();
